// extracted by mini-css-extract-plugin
export var fullHeightState = "_1s-7";
export var headerCell = "_1s-1";
export var loadingStateCell = "_1s-4";
export var rowWrapper = "_1s-3";
export var standaloneTable = "_1s-8";
export var standaloneTableWithBodyFill = "_1s-9";
export var stateCell = "_1s-5";
export var table = "_1s-0";
export var tableBodyFiller = "_1s-6";
export var white = "_1s-2";